import { $host, $authHost, isDev } from './index'
import { httpPoint } from '../utils/const'


export const sendSupportMessage = async (message) => {
    const { data } = await $authHost.post( httpPoint.supportchat + 'send', {
        message
    });

    return data;
};

export const getSupport = async (page, limit) => {
    const { data } = await $authHost.post(httpPoint.supportchat + 'getAll', {page, limit})
    return data
}


